/* Judge.me review widget: replaces the native sort dropdown (which can't be styled) with a
   brand-styled listbox. The original <select> stays in the DOM, hidden, and is still the
   source of truth — choosing an option sets its value and fires `change`, so Judge.me's
   own sorting logic runs unchanged. The widget renders lazily and re-renders on its own,
   so new sort controls are picked up with a MutationObserver. */
(function () {
  'use strict';

  var widget = document.getElementById('judgeme_product_reviews');
  if (!widget) return;

  var uid = 0;

  function enhance(wrap) {
    if (wrap.querySelector('.clx-sort__toggle')) return;
    var select = wrap.querySelector('select');
    if (!select) return;

    var menuId = 'clx-sort-menu-' + ++uid;
    var label = wrap.querySelector('label');

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'clx-sort__toggle';
    toggle.setAttribute('aria-haspopup', 'listbox');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', menuId);
    toggle.setAttribute('aria-label', label ? label.textContent.trim() : 'Sort reviews by');

    var menu = document.createElement('ul');
    menu.className = 'clx-sort__menu';
    menu.id = menuId;
    menu.setAttribute('role', 'listbox');
    menu.hidden = true;

    function build() {
      menu.innerHTML = '';
      Array.prototype.forEach.call(select.options, function (opt) {
        var li = document.createElement('li');
        li.className = 'clx-sort__option';
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', String(opt.value === select.value));
        li.tabIndex = -1;
        li.dataset.value = opt.value;
        li.textContent = opt.textContent.trim();
        menu.appendChild(li);
      });
    }

    function onOutside(e) {
      if (!wrap.contains(e.target)) close(false);
    }

    function open() {
      build();
      menu.hidden = false;
      wrap.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      var current = menu.querySelector('[aria-selected="true"]') || menu.firstElementChild;
      if (current) current.focus();
      document.addEventListener('click', onOutside, true);
    }

    function close(returnFocus) {
      menu.hidden = true;
      wrap.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onOutside, true);
      if (returnFocus) toggle.focus();
    }

    function choose(li) {
      if (select.value !== li.dataset.value) {
        select.value = li.dataset.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      close(true);
    }

    toggle.addEventListener('click', function () {
      if (menu.hidden) open(); else close(true);
    });
    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        open();
      }
    });

    menu.addEventListener('click', function (e) {
      var li = e.target.closest('.clx-sort__option');
      if (li) choose(li);
    });
    menu.addEventListener('keydown', function (e) {
      var items = Array.prototype.slice.call(menu.children);
      var i = items.indexOf(document.activeElement);
      switch (e.key) {
        case 'ArrowDown': e.preventDefault(); items[Math.min(i + 1, items.length - 1)].focus(); break;
        case 'ArrowUp': e.preventDefault(); items[Math.max(i - 1, 0)].focus(); break;
        case 'Home': e.preventDefault(); items[0].focus(); break;
        case 'End': e.preventDefault(); items[items.length - 1].focus(); break;
        case 'Enter':
        case ' ': e.preventDefault(); if (items[i]) choose(items[i]); break;
        case 'Escape': e.preventDefault(); close(true); break;
        case 'Tab': close(false); break;
      }
    });

    wrap.classList.add('clx-sort--enhanced');
    wrap.appendChild(toggle);
    wrap.appendChild(menu);
  }

  function scan() {
    widget.querySelectorAll('.jm-sort-filter').forEach(enhance);
  }

  scan();
  new MutationObserver(scan).observe(widget, { childList: true, subtree: true });
})();
